/**
 * @typedef {Object} Settings
 * @property {string} API_ENDPOINT
 * @property {string} PINGA_APP_MAIN_URL
 * @property {string} SITE_DOMAIN
 * @property {string} MAIN_SITE_REWRITE_PATH
 * @property {string} ENABLE_LANG_SWITCHER
 */
export const applicationSettings = {
  API_ENDPOINT: process.env.API_URL,
  PINGA_APP_MAIN_URL: process.env.PINGA_APP_MAIN_URL,
  SITE_DOMAIN: process.env.SITE_DOMAIN,
  MAIN_SITE_REWRITE_PATH: process.env.MAIN_SITE_REWRITE_PATH,
  ENABLE_LANG_SWITCHER: process.env.ENABLE_LANG_SWITCHER,
};
